import React from 'react';
import { PrimaryButton, TransparentButton } from '@bloomberg/media-ui-core';
import { Lock } from '@bloomberg/media-ui-icons';
import { Overlay, type OverlayProps } from '@bloomberg/media-ui-overlay';
import RegUIClient from 'reg-ui-client';

import styles from './styles.module.css';

const DEFAULT_HEADER_TEXT = 'Subscriber Benefit';
const DEFAULT_IN_SOURCE = 'subscriber-only-benefit';
const DEFAULT_CHILDREN: React.ReactNode = (
  <p className={styles.defaultText}>
    This feature is only available to bloomberg.com subscribers.
  </p>
);

export interface SubscriberOnlyBenefitOverlayProps
  extends Omit<Omit<OverlayProps, 'headerText'>, 'Icon'> {
  client?: RegUIClient;
  headerText?: string;
  inSource?: string;
  children?: React.ReactNode;
}

export const SubscriberOnlyBenefitOverlay: React.FC<
  SubscriberOnlyBenefitOverlayProps
> = (props) => {
  const {
    client,
    headerText = DEFAULT_HEADER_TEXT,
    inSource = DEFAULT_IN_SOURCE,
    children = DEFAULT_CHILDREN,
    placement,
  } = props;

  const isNewsletterSubscriber =
    (client?.getEntitlementFeatures() || []).length > 0;
  const primaryLinkUrl = isNewsletterSubscriber
    ? `/portal/subscription?triggerSubscriptionUpgradeModal=true&in_source=${inSource}`
    : `/subscriptions?in_source=${inSource}`;
  const primaryButtonText = isNewsletterSubscriber ? 'Upgrade' : 'Subscribe';

  return (
    <Overlay
      {...props}
      headerText={headerText}
      Icon={<Lock />}
      placement={placement}
    >
      <>
        {children}
        <div className={styles.buttonContainer}>
          <PrimaryButton version="phoenix" linkUrl={primaryLinkUrl} fullWidth>
            {primaryButtonText}
          </PrimaryButton>
          {!client?.isLoggedIn() && (
            <TransparentButton
              version="phoenix"
              fullWidth
              className={styles.signInButton}
              onClick={() =>
                client?.linkToSignIn({
                  in_source: inSource,
                  leadSource: inSource,
                })
              }
            >
              Sign In
            </TransparentButton>
          )}
        </div>
      </>
    </Overlay>
  );
};
